import { type SearchRequest } from '@searchkit/api';

import { createQueryFactory } from '~/search-domain/pipelines/event-overview/query-factory';
import { type SearchDomainContext } from '~/search-domain/types';

export function buildEventOverviewQuery(_context: SearchDomainContext, searchRequest: SearchRequest) {
  if (searchRequest.request.type === 'facet') {
    return searchRequest;
  }

  const queryFactory = createQueryFactory();
  return queryFactory(searchRequest);
}
